import initApp from "./engine/plugins/initApp"
import BrowserRouter from "./engine/plugins/BrowserRouter"
import Redux from "./engine/plugins/Redux"
import ApplySaga from "./engine/plugins/ApplySaga"
import AddModule from "./engine/plugins/AddModule"
import { setStore } from "./engine/plugins/BridgeStore"
// import registerServiceWorker from 'plugins/registerServiceWorker'

import App from "./routes/App"
import * as api from "./engine/modules/api"
import * as applications from "./engine/modules/applications"
import * as notifications from "./engine/modules/notifications"
import * as features from "./engine/modules/features"
import * as status from "./engine/modules/status"
import * as statusModel from "./engine/modules/EventType/StatusModel"
import * as entity from "./engine/modules/entity"
import * as collection from "./engine/modules/collection"
import * as session from "./engine/modules/session"
import * as validate from "./engine/modules/validate"
import * as list from "./engine/modules/lists"
import * as fields from "./engine/modules/resourceTypeFields"
import * as reduxForm from "./engine/modules/reduxForm"
import * as ui from "./engine/modules/ui"
import * as rolesForm from "./engine/modules/rolesForm"
import * as currentUser from "./engine/modules/currentUser"
import * as calendar from "./engine/modules/calendar"
import * as eventResources from "./engine/modules/eventResources"

// plan
import * as planEvents from "./engine/modules/Plan/PlanEvents"

import * as notificationDirector from "./modules/notificationDirector"
import { register as rest } from "./engine/modules/rest"

/* That's an array of plugins, which configures your application */
export default [
  initApp(App),
  BrowserRouter,
  Redux,
  ApplySaga,
  setStore,
  // registerServiceWorker, // We have no HTTPS server yet, so skip it
  AddModule(session),
  AddModule(entity),
  AddModule(collection),
  AddModule(reduxForm),

  /* Application list module */
  AddModule(notifications),

  /* Application list module */
  AddModule(applications),

  /* Features list module */
  AddModule(features),

  /* Plan validate module */
  AddModule(validate),

  /* List module */
  AddModule(list),

  /* Fields module */
  AddModule(fields),

  AddModule(ui),

  AddModule(rolesForm),

  AddModule(currentUser),

  AddModule(api),
  AddModule(calendar),
  AddModule(eventResources),

  // statuses
  AddModule(status),

  AddModule(statusModel),

  // plan
  AddModule(planEvents),

  /* The module, which react to actions from another modules and
   * reflect them as notifications */
  AddModule(notificationDirector),

  rest, // Hm. Nice idea, I can put to chain register functions, except manually call plugin
]

// Тег планнера для шаблонов отчета
export const PLANNER_TAG = `planner`

// id базового эелмента (он скроллится и меняет размер)
export const BASE_ELEMENT_ID = `base-element`
